import React from 'react';
import { Stack, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { commonMessages } from 'utils/commonMessages';
import { NewProduct } from './CreateProductStep';

interface CreateProductStepCompletedProps {
  newProduct: NewProduct
}

export const CreateProductStepCompleted: React.FC<CreateProductStepCompletedProps> = ({ newProduct }) => {
  const { formatMessage } = useIntl();

  return (
    <Stack gap={2} direction='row' marginLeft={7} marginTop={1} color='text.secondary'>
      <Stack>
        <Typography>{formatMessage(commonMessages.productName)}</Typography>
        <Typography>{formatMessage(commonMessages.productSku)}</Typography>
      </Stack>
      <Stack>
        <Typography fontWeight={500}>{newProduct.name}</Typography>
        <Typography fontWeight={500}>{newProduct.sku}</Typography>
      </Stack>
    </Stack>
  );
};